// ABOUTME: Envuelve el ImageSegmenter de MediaPipe (selfie multiclase) en modo vídeo. Segmenta
// ABOUTME: una copia reducida del fotograma para que la máscara sea barata de subir a la GPU.
import { FilesetResolver, ImageSegmenter } from "@mediapipe/tasks-vision";

export interface CategoryMask {
  data: Uint8Array;
  width: number;
  height: number;
}

export interface Segmenter {
  /** Máscara de la imagen (misma proporción que la fuente, resolución reducida). */
  segment(source: HTMLVideoElement | HTMLCanvasElement | HTMLImageElement, timestampMs: number): CategoryMask;
  close(): void;
}

/** Anchura a la que se reduce el fotograma antes de segmentar (el modelo trabaja a 256x256). */
const TARGET_WIDTH = 320;

export async function createSegmenter(): Promise<Segmenter> {
  const base = import.meta.env.BASE_URL.replace(/\/$/, "");
  const fileset = await FilesetResolver.forVisionTasks(`${base}/wasm`);
  const segmenter = await ImageSegmenter.createFromOptions(fileset, {
    baseOptions: { modelAssetPath: `${base}/models/selfie_multiclass_256x256.tflite`, delegate: "GPU" },
    runningMode: "VIDEO",
    outputCategoryMask: true,
    outputConfidenceMasks: false,
  });
  const small = document.createElement("canvas");
  const ctx = small.getContext("2d", { willReadFrequently: false });
  if (!ctx) throw new Error("Canvas 2D no disponible");
  let lastTimestamp = -1;

  return {
    segment(source, timestampMs) {
      const srcW = source instanceof HTMLVideoElement ? source.videoWidth : source.width;
      const srcH = source instanceof HTMLVideoElement ? source.videoHeight : source.height;
      const scale = TARGET_WIDTH / srcW;
      const w = Math.round(srcW * scale);
      const h = Math.round(srcH * scale);
      if (small.width !== w || small.height !== h) {
        small.width = w;
        small.height = h;
      }
      ctx.drawImage(source, 0, 0, w, h);
      // MediaPipe exige timestamps estrictamente crecientes.
      const ts = timestampMs <= lastTimestamp ? lastTimestamp + 1 : timestampMs;
      lastTimestamp = ts;
      const result = segmenter.segmentForVideo(small, ts);
      const mask = result.categoryMask;
      if (!mask) throw new Error("El segmentador no devolvió máscara");
      const out = { data: Uint8Array.from(mask.getAsUint8Array()), width: mask.width, height: mask.height };
      result.close();
      return out;
    },
    close() {
      segmenter.close();
    },
  };
}
